import { render, staticRenderFns } from "./PaymentCreate.vue?vue&type=template&id=d2f6b552"
import script from "./PaymentCreate.vue?vue&type=script&lang=js"
export * from "./PaymentCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports